// 
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useArticles } from '../contexts/ArticleContext';
import './ArticleDetail.css';

const ArticleDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getArticleById, deleteArticle } = useArticles();
  const article = getArticleById(id);

  const [isDeleting, setIsDeleting] = useState(false);
  const [message, setMessage] = useState('');

  if (!article) {
    return (
      <div className="article-not-found">
        <h2>文章不存在</h2>
        <p>抱歉，您访问的文章可能已被删除或不存在。</p>
        <button onClick={() => navigate('/')} className="back-btn">
          返回首页
        </button>
      </div>
    );
  }

  const handleEdit = () => {
    navigate(`/write/${id}`);
  };

  const handleDelete = async () => {
    if (!window.confirm('确定要删除这篇文章吗？此操作不可撤销。')) {
      return;
    }

    setIsDeleting(true);
    setMessage('正在删除文章...');

    try {
      await deleteArticle(parseInt(id));
      setMessage('文章已成功删除！正在跳转到首页...');
      
      // 3秒后跳转到首页
      setTimeout(() => {
        navigate('/');
      }, 3000);
    } catch (error) {
      setMessage('删除失败，请重试');
      setIsDeleting(false);
    }
  };

  const formatMarkdown = (content) => {
    // 简单的Markdown转换
    const lines = content.split('\n');
    return lines.map((line, index) => {
      // 处理标题
      if (line.startsWith('# ')) {
        return <h2 key={index}>{line.substring(2)}</h2>;
      }
      if (line.startsWith('## ')) {
        return <h3 key={index}>{line.substring(3)}</h3>;
      }
      if (line.startsWith('### ')) {
        return <h4 key={index}>{line.substring(4)}</h4>;
      }
      
      // 处理代码块
      if (line.startsWith('```')) {
        return <pre key={index}>{line.substring(3)}</pre>;
      }
      
      // 处理列表
      if (line.startsWith('- ')) {
        return <li key={index}>{line.substring(2)}</li>;
      }
      
      // 处理普通段落
      if (line.trim()) {
        // 处理加粗文本
        const boldText = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        // 处理斜体文本
        const italicText = boldText.replace(/\*(.*?)\*/g, '<em>$1</em>');
        // 处理链接
        const linkedText = italicText.replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" target="_blank">$1</a>');
        // 处理图片
        const imageText = linkedText.replace(/!\[(.*?)\]\((.*?)\)/g, '<img src="$2" alt="$1" />');
        
        return <p key={index} dangerouslySetInnerHTML={{ __html: imageText }} />;
      }
      
      // 空行
      return <br key={index} />;
    });
  };

  return (
    <div className="article-detail">
      <div className="article-header">
        <div className="article-header-content">
          <span className="article-category">{article.category}</span>
          <h1 className="article-title">{article.title}</h1>
          <div className="article-meta">
            <span className="article-author">作者：{article.author}</span>
            <span className="article-date">发布日期：{article.date}</span>
            <span className="article-read-time">阅读时间：{article.readTime}</span>
          </div>
        </div>
      </div>
      
      <div className="article-content">
        <div className="article-excerpt">
          <h3>文章摘要</h3>
          <p>{article.excerpt}</p>
        </div>
        
        <div className="article-body">
          <h3>正文内容</h3>
          <div className="article-text">
            {formatMarkdown(article.content)}
          </div>
        </div>
        
        <div className="article-tags">
          <h3>文章标签</h3>
          <div className="tags-container">
            {article.tags.map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
        </div>
      </div>
      
      {message && (
        <div className={`article-message ${message.includes('成功') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
      
      <div className="article-actions">
        <button onClick={() => navigate(-1)} className="action-btn back-btn">
          返回列表
        </button>
        <button onClick={handleEdit} className="action-btn edit-btn">
          编辑文章
        </button>
        <button 
          onClick={handleDelete} 
          className="action-btn delete-btn"
          disabled={isDeleting}
        >
          {isDeleting ? '删除中...' : '删除文章'}
        </button>
      </div>
    </div>
  );
};

export default ArticleDetail;